import {
  Box,
  Button,
  Fab,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  getAllCustomerDetail,
  getAllCustomerDetailXlsx,
  getAllCustomerDetails,
} from "../../common/searchModal/api";
import UserCard from "../../common/searchModal/userCard";
import { searchedElementDisplay } from "../../common/searchModal/function";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import { Form } from "./form";
import { getAllGroup } from "../customerGrouping/customerGroupingApi";
import { Filter } from "../../common/fiterComp";
import TableCard from "./tableCards";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useTheme } from "@emotion/react";
import { ArrowBackIcon } from "../../common/icon";
import { useNavigate } from "react-router";

export const CustomeDetail = ({ report, gridSize }) => {
  // const [collection, setCollection] = useState([])
  const [search, setSearch] = useState("");
  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);

  const [open, setOpen] = useState(false);
  const [selectedData, setSeletecData] = useState(null);
  const [value, setValue] = useState("all");

  const [formDataModal, setFormDataModal] = useState(null);
  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const [searchCurrentModal, setSearchCurrentModal] = useState("");
  const [collection, setCollection] = useState([]);
  const [collectionOption, setCollectionOption] = useState([]);
 const navigate = useNavigate();

  const [getDataPayload, setGetDataPykoad] = useState({
    page: 1,
    pageSize: 1000,
    filter: "string",
    search: "",
    filter2: "",
    search2: "",
  });
  useEffect(() => {}, []);
  useEffect(() => {
    getAllCustomerDetails(
      {
        ...getDataPayload,
      },
      (data) => {
        setCollection(data);
        console.log("data detail ", data);
      }
    );
  }, [getDataPayload]);

  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   "user/api/v1/CounterSales/GetOverAllCounterSalesDetailsXlsx",
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await getAllCustomerDetailXlsx(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };
  const isUpcomingDate = (dateStr) => {
    if (!dateStr) return false;
    const today = new Date();
    const target = new Date(dateStr);

    target.setFullYear(today.getFullYear());

    if (target < today) {
      target.setFullYear(today.getFullYear() + 1);
    }

    const diff = (target - today) / (1000 * 60 * 60 * 24);
    return diff >= 0 && diff <= 30;
  };

  const applyClientSideFilter = (data, filterKey, searchValue) => {
    if (filterKey === "birthday") {
      return data.filter((cust) => isUpcomingDate(cust.birthdate));
    }

    if (filterKey === "Anniversarydate") {
      return data.filter((cust) => isUpcomingDate(cust.anniversaryDate));
    }

    if (filterKey === "customerGroup") {
      return data.filter((cust) => cust.customerGroup === searchValue);
    }

    return data;
  };

  const filteredCollection = applyClientSideFilter(
    collection,
    getDataPayload?.filter,
    getDataPayload?.search
  );
  const theme = useTheme();
  const isAbove1440 = useMediaQuery("(min-width:1440px)");
  return (
    <Box
      sx={{
        px: { xs: "10px", sm: "30px" },
        py: "17px",
        background: "#ede9ff",
        minHeight: "100vh",
      }}
    >
      <Grid container alignItems="center" spacing={2}>
        {/* {!report && <DynamicBreadcrumbs />} */}
        <Grid item>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/home")}
          />
        </Grid>
        <Grid
          item
          xs={report ? 11 : 5}
          sm={report ? 11 : 6}
          md={report ? 11 : 7}
          lg={report ? (isAbove1440 ? 11 : 11) : isAbove1440 ? 8 : 7}
          sx={{}}
        >
          <Box
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              paddingLeft: "20px",
              borderRadius: 2,
              color: "#01008B", // optional text color
              textAlign: "left",
            }}
          >
            <Typography
              variant="h6"
              fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
            >
              {!!report ? "Customer Information Report" : "Customer Details"}
            </Typography>
          </Box>
        </Grid>

        {!report && (
          <Grid item xs={6} md={4} sm={5} lg={isAbove1440 ? 3 : 4}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                setOpen(true);
              }}
              sx={{
                height: "40px",
                backgroundColor: "#14008B",
                padding: "0px",
                fontSize: { xs: "10px", sm: "13px", md: "15px" },
              }}
              endIcon={<AddIcon />}
            >
              Add Customer Information
            </Button>
          </Grid>
        )}

        <Grid
          item
          xs={report ? 12 : 12}
          sm={report ? 12 : 6}
          md={report ? 10 : 6}
          sx={{ marginBottom: { xs: "0px", sm: "0px", md: "10px" } }}
        >
          <TextField
            size="small"
            value={selectedData?.name}
            onChange={(e) => {
              setSeletecData({ ...selectedData, name: e.target.value });
            }}
            label="Customer Name"
            sx={{
              width: "100%",
              backgroundColor: "white",
              borderRadius: "5px",
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              "& .MuiOutlinedInput-root": { boxShadow: "none" },
            }}
            // size={report ? "small" : "medium"}
            id="outlined-basic-search"
            variant="outlined"
            InputLabelProps={{
              sx: {
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              },
            }}
            InputProps={{
              sx: {
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              },
              endAdornment: (
                <InputAdornment position="end">
                  {search ? (
                    <CloseIcon
                      onClick={() => {
                        setSearch("");
                      }}
                      sx={{ cursor: "pointer" }}
                    />
                  ) : (
                    <SearchIcon color="primary" />
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {/* Download Button */}
        {report ? (
          <Grid
            item
            md={2}
            xs={12}
            sx={{
              padding: "0px",
              marginBottom: "10px",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={() =>
                downloadXLSXFile({
                  ...getDataPayload,
                })
              }
              sx={{
                textTransform: "capitalize",
                width: {
                  xs: "100%",
                  // sm: "auto",
                },
                // p: "10px",
                whiteSpace: "nowrap",
                zIndex: "0",
              }}
              endIcon={<DownloadIcon />}
            >
              Download
            </Button>
          </Grid>
        ) : (
          <Grid
            item
            sm={6}
            xs={12}
            sx={{
              padding: "0px",
              marginBottom: "20px",
              borderRadius: "5px",
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                paddingX: "10px",
                borderRadius: "5px",
              }}
            >
              <Filter
                setGetDataPykoad={setGetDataPykoad}
                getDataPayload={getDataPayload}
                groupFilter
              />
            </Box>
          </Grid>
        )}

        <Filter
          setGetDataPykoad={setGetDataPykoad}
          getDataPayload={getDataPayload}
          categoryFilter
        />

        {/* <Grid item xs={12} sm={12}>
          <Box sx={{ height: "55vh", overflowY: "auto" }}>
            {collection.map((item, index) => {
              if (searchedElementDisplay(item, selectedData?.name)) {
                return null;
              }
              return (
                <UserCard
                  key={"employee" + index}
                  data={item}
                  callBack={() => {
                    setOpen(true)
                    setFormDataModal(item)
                    // callback(item)
                    // getUnpaid({
                    //   customerMobile: item?.mobile,
                    // });
                    // setBillData({
                    //   ...item,
                    //   customerMobile: item?.mobile,
                    //   customer: item?.name,
                    // // });
                    // setSearch(item?.name)
                    // setUSerObject(item)
                    // callSearchApi(item?.name)
                    // setSearchModal(false)
                  }}
                />
              );
            })}
          </Box>
        </Grid> */}

        <Grid item xs={12}>
          <Grid
            container
            sx={{ p: "10px", background: "white", borderRadius: "12px" }}
          >
            <Grid item xs={12}>
              <Grid
                container
                sx={{ borderBottom: "1.5px solid black", paddingTop: "10px" }}
              >
                <Grid item xs={0} sm={0} md={1}></Grid>

                <Grid item xs={2}>
                  <Typography
                    sx={{
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      // overflow: "Hidden",
                      // display: "-webkit-box",
                      // "-webkit-line-clamp": "1",
                      // "-webkit-box-orient": "vertical",
                      // fontWeight: 700,
                      p: "0px 10px",
                      color: "#01008B",
                      // marginLeft: "30px",
                      fontWeight: 500,
                    }}
                  >
                    Customer Name
                  </Typography>
                </Grid>

                <Grid item xs={3} pl={{ xs: 1, sm: 1, md: 4, lg: 10 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      // overflow: "Hidden",
                      // display: "-webkit-box",
                      // "-webkit-line-clamp": "1",
                      // "-webkit-box-orient": "vertical",
                      // fontWeight: 700,
                      p: "0px 10px",
                      color: "#01008B",
                      // marginLeft: "30px",
                      fontWeight: 500,
                    }}
                  >
                    {report ? "Phone Number" : "Mobile No."}
                  </Typography>
                </Grid>

                <Grid item xs={2} pl={{ xs: 0, sm: 2, md: 2, lg: 6 }}>
                  {" "}
                  <Typography
                    sx={{
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      // overflow: "Hidden",
                      // display: "-webkit-box",
                      // "-webkit-line-clamp": "1",
                      // "-webkit-box-orient": "vertical",
                      // fontWeight: 700,
                      p: "0px 10px",
                      color: "#01008B",
                      // marginLeft: "30px",
                      fontWeight: 500,
                    }}
                  >
                    Birthday
                  </Typography>
                </Grid>

                <Grid item xs={2} pl={{ xs: 5, sm: 7, md: 0, lg: 6 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      // overflow: "Hidden",
                      // display: "-webkit-box",
                      // "-webkit-line-clamp": "1",
                      // "-webkit-box-orient": "vertical",
                      // fontWeight: 700,
                      p: "0px 10px",
                      color: "#01008B",
                      // marginLeft: "30px",
                      fontWeight: 500,
                    }}
                  >
                    Anniversary
                  </Typography>
                </Grid>
                <Grid item xs={0} sm={0} md={1}></Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ height: "60vh", overflow: "auto", marginTop: "4px" }}
            >
              {filteredCollection?.map((item, i) => {
                if (searchedElementDisplay(item, selectedData?.name)) {
                  return null;
                }
                return (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    // lg={6}
                    key={"payamentRecpt" + i}
                    sx={{ p: "0px" }}
                  >
                    <TableCard
                      item={item}
                      callback={() => {
                        if (!report && !gridSize) {
                          setOpen(true);
                          setFormDataModal(item);
                        }
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>

        <Form
          open={open}
          setOpen={setOpen}
          formDataModal={formDataModal}
          setFormDataModal={setFormDataModal}
          callback={() => {
            getAllCustomerDetails(
              {
                page: 1,
                pageSize: 1000,
                filter: "",
                search: "",
                filter2: "",
                search2: "",
              },
              (data) => {
                setCollection(data);
                console.log("data detail ", data);
              },
            );
          }}
        />
      </Grid>
    </Box>
  );
};
